import useModal from '../../../useModal';
import UseContext from '../../../../../hooks/useContext';
import Modalheader from '../../../components/header';
import ModalBody from '../../../components/body';
import ModalFooter from '../../../components/footer';
import Button from '../../../../button';
import ApiDatabase from '../../../../../server';
import { useState } from 'react';
import { toast } from 'react-toastify';

const ModalInvoiceImportUnit = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const token = localStorage.getItem('xsrfToken');

  const invoice = modalData?.invoices?.[0] || {};
  const year = modalData?.year || '';
  const month = modalData?.month || '';

  const [isLoading, setIsLoading] = useState(false);
  const [pushPennylane, setPushPennylane] = useState(false);

  const handleConfirm = () => {
    setIsLoading(true);
    ApiDatabase.importInvoices(
      {
        token,
        year,
        month,
        paid: true,
        invoice_numbers: [invoice.invoice_number],
        pennylane_invoice_numbers: pushPennylane ? [invoice.invoice_number] : undefined,
      },
      () => {
        setIsLoading(false);
        let msg = 'Import lancé.';
        if (pushPennylane) msg += ' La facture sera aussi envoyée sur PennyLane.';
        toast.success(msg);
        setModalDataReturn({
          action: 'invoices_imported',
          invoice_numbers: [invoice.invoice_number],
        });
        toggle();
      },
      (err) => {
        setIsLoading(false);
        toast.error(err.response?.data?.error || 'Erreur');
      }
    );
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    try {
      const [y, m, d] = dateStr.slice(0, 10).split('-');
      return `${d}/${m}/${y}`;
    } catch {
      return dateStr;
    }
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Importer une facture
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-3 text-sm">
          <div>
            <strong>N° Facture :</strong> {invoice.invoice_number}
          </div>
          <div>
            <strong>Entreprise :</strong> {invoice.company_name}
          </div>
          <div>
            <strong>Date :</strong> {formatDate(invoice.date_facture)}
          </div>
          <div>
            <strong>Montant :</strong>{' '}
            {invoice.amount ? `${Number(invoice.amount).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €` : '-'}
          </div>
          <label className="flex items-center gap-2 cursor-pointer mt-2">
            <input
              type="checkbox"
              checked={pushPennylane}
              onChange={() => setPushPennylane(!pushPennylane)}
            />
            Importer aussi sur PennyLane
          </label>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="flex gap-2">
          <Button onClick={toggle} size="LG" color="SECONDARY">
            Annuler
          </Button>
          <Button onClick={handleConfirm} size="LG" disabled={isLoading}>
            {isLoading ? 'Import en cours...' : 'Confirmer'}
          </Button>
        </div>
      </ModalFooter>
    </>
  );
};

export default ModalInvoiceImportUnit;
